import { AutocompleteAdapter } from 'components/enhanced/form/adapters/selects/AutocompleteAdapter';
import { IdentityField } from 'components/enhanced/form/fields/IdentityField';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { ISupplier } from '../types';
import SupplierCsvMappingFields from './SupplierCsvMappingFields';
import {
  DEFAULT_ORDER_SEND_FORMAT,
  toFormReceptionFormat,
  DEFAULT_RECEPTION_FORMAT,
  DEFAULT_CSV_FORMAT
} from '../constants';

type SupplierIntegrationFormatFieldsProps = {
  supplier: ISupplier;
  disableEdit?: boolean;
  orderSendFormatOptions: { value: string; display_name: string }[];
  receptionFormatOptions: { value: string; display_name: string }[];
  csvFormatOptions: { value: string; display_name: string }[];
  resolveOptionInit: (
    options: { value: string; display_name: string }[],
    currentValue: string | undefined,
    defaultValue: string
  ) => { value: string; display_name: string };
};

export const SupplierIntegrationFormatFields = ({
  supplier,
  disableEdit,
  orderSendFormatOptions,
  receptionFormatOptions,
  csvFormatOptions,
  resolveOptionInit
}: SupplierIntegrationFormatFieldsProps) => {
  const { t } = useTranslation();
  const formState = useFormState();
  const receptionFormat = formState.values.reception_format;

  return (
    <>
      <IdentityField
        gridSpan={4}
        name="order_send_format"
        component={AutocompleteAdapter}
        initValue={resolveOptionInit(
          orderSendFormatOptions,
          supplier.order_send_format,
          DEFAULT_ORDER_SEND_FORMAT
        )}
        options={orderSendFormatOptions}
        optionValue="value"
        optionLabel="display_name"
        label={t('entities.supplier.order_send_format')}
        autoSelect={false}
        disabled={disableEdit}
      />

      <IdentityField
        gridSpan={4}
        name="reception_format"
        component={AutocompleteAdapter}
        initValue={resolveOptionInit(
          receptionFormatOptions,
          toFormReceptionFormat(supplier.reception_format),
          DEFAULT_RECEPTION_FORMAT
        )}
        options={receptionFormatOptions}
        optionValue="value"
        optionLabel="display_name"
        label={t('entities.supplier.reception_format')}
        autoSelect={false}
        disabled={disableEdit}
      />
      {receptionFormat === 'csv' && (
        <>
          <IdentityField
            gridSpan={4}
            name="csv_format"
            component={AutocompleteAdapter}
            initValue={resolveOptionInit(csvFormatOptions, supplier.csv_format, DEFAULT_CSV_FORMAT)}
            options={csvFormatOptions}
            optionValue="value"
            optionLabel="display_name"
            label={t('entities.supplier.csv_format')}
            autoSelect={false}
            disabled={disableEdit}
          />
          <SupplierCsvMappingFields disableAutoLayout={true} disabled={disableEdit} />
        </>
      )}
    </>
  );
};

export default SupplierIntegrationFormatFields;
